import React, { forwardRef } from 'react';
import { Divider } from '../../legacy/Divider';
import { identifyComponent } from '../../util';

export const ListDivider = forwardRef<HTMLLIElement>((_, ref) => (
  <li data-component="ListDivider" ref={ref} {...identifyComponent('list-divider')}>
    <Divider />
  </li>
));

ListDivider.displayName = 'ListDivider';
